import TournamentCatalogItem from './TournamentCatalogItem.vue'
import { TournamentGameType } from '@/api/tournament'
export default TournamentCatalogItem
export { TournamentCatalogItem }
export interface TournamentGameTypeOption {
  text: string
  value: TournamentGameType
}
